"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Dropdown = require("../../Dropdown");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var _menuBubble = _interopRequireDefault(require("../../assets/images/menu-bubble.svg"));

var _menuBubbleBlack = _interopRequireDefault(require("../../assets/images/menu-bubble-black.svg"));

var _menuWhite = _interopRequireDefault(require("../../assets/images/menu-white.svg"));

var _caliberDark = _interopRequireDefault(require("../../assets/images/caliber-dark.png"));

var _caliber = _interopRequireDefault(require("../../assets/images/caliber.png"));

var _homebridgeLogoDark = _interopRequireDefault(require("../../assets/images/homebridge-logo-dark.svg"));

var _homebridgeLogoWhite = _interopRequireDefault(require("../../assets/images/homebridge-logo-white.svg"));

var _guaranteedRateLogoDark = _interopRequireDefault(require("../../assets/images/guaranteed-rate-logo-dark.svg"));

var _guaranteedRateLogoWhite = _interopRequireDefault(require("../../assets/images/guaranteed-rate-logo-white.svg"));

var _homepointLogoBlue = _interopRequireDefault(require("../../assets/images/homepoint-logo-blue.svg"));

var _homepointLogoWhite = _interopRequireDefault(require("../../assets/images/homepoint-logo-white.svg"));

var _synergyOneLogoBlack = _interopRequireDefault(require("../../assets/images/synergy-one-logo-black.svg"));

var _synergyOneLogoWhite = _interopRequireDefault(require("../../assets/images/synergy-one-logo-white.svg"));

var _figureDark = _interopRequireDefault(require("../../assets/images/figure-dark.svg"));

var _figure = _interopRequireDefault(require("../../assets/images/figure.svg"));

var _Constant = require("../../Constant");

var _Constant2 = require("../Constant");

var _Text = require("../../Text");

var _menu = _interopRequireDefault(require("../../assets/images/menu.svg"));

var _theme, _theme2, _theme3, _theme4;

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  width: ", "px;\n  max-width: 100%;\n  height: 100%;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  &:before {\n    content: '';\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: left center;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    @media (forced-colors: active) and (prefers-color-scheme: light) {\n      background-image: url(", ");\n    }\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    width: ", "px;\n\n    &:before {\n      background-image: url(", ");\n      @media (forced-colors: active) and (prefers-color-scheme: dark) {\n        background-image: url(", ");\n      }\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          left: 50%;\n          margin-left: -34px;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          top: 0;\n          bottom: 0;\n          left: 70px;\n          right: 70px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n  position: absolute;\n  ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    top: unset;\n    bottom: unset;\n    right: unset;\n    display: block;\n    left: 62px;\n    margin-left: unset;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 30px;\n  top: 20px;\n\n  @media print, screen and (min-width: ", "px) {\n    left: unset;\n    top: unset;\n    right: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  position: relative;\n  width: 21px;\n  height: 13px;\n  cursor: pointer;\n  color: ", ";\n\n  &:before {\n    content: '';\n    background: url(", ") no-repeat left center;\n    background-size: 100% 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    @media (forced-colors: active) and (prefers-color-scheme: light) {\n      background: url(", ") no-repeat left center;\n    }\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    width: 35px;\n    height: 55px;\n\n    &:before {\n      background: url(", ") no-repeat left center;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &&& {\n    @media print, screen and (min-width: ", "px) {\n      border-right: none;\n      padding-right: 10px;\n    }\n\n    // TwoColumn used two menus - these are the styles passed to the mobile one\n    @media print, screen and (max-width: ", "px) {\n      ul {\n        top: 55px;\n        left: 0;\n        right: 0;\n        position: fixed;\n        border-right: none;\n        border-left: none;\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  z-index: 1;\n  background-color: ", ";\n  height: 55px;\n  padding-top: 11px;\n  /* this border defines the navbar for Windows high contrast users */\n  border-bottom: 1px solid transparent;\n\n  /* The header is not fixed on small devices in landscape mode or when zoomed in */\n  @media print, screen and (max-width: ", "px) and (min-height: 480px) {\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    background-color: ", ";\n    position: relative;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LogoLight = (0, _styledTheming.default)('mode', (_theme = {
  figure: _figure.default
}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _homebridgeLogoWhite.default), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _synergyOneLogoWhite.default), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _guaranteedRateLogoWhite.default), (0, _defineProperty2.default)(_theme, "homepoint", _homepointLogoWhite.default), (0, _defineProperty2.default)(_theme, "petersendean", _figure.default), (0, _defineProperty2.default)(_theme, "caliber", _caliber.default), (0, _defineProperty2.default)(_theme, "pella", _figure.default), _theme));
var LogoDark = (0, _styledTheming.default)('mode', (_theme2 = {
  figure: _figureDark.default
}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, _homebridgeLogoDark.default), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, _guaranteedRateLogoDark.default), (0, _defineProperty2.default)(_theme2, "homepoint", _homepointLogoBlue.default), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, _synergyOneLogoBlack.default), (0, _defineProperty2.default)(_theme2, "petersendean", _figureDark.default), (0, _defineProperty2.default)(_theme2, "caliber", _caliberDark.default), (0, _defineProperty2.default)(_theme2, "pella", _figureDark.default), _theme2));
var MenuBubble = (0, _styledTheming.default)('mode', (_theme3 = {
  figure: _menuBubble.default
}, (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEBRIDGE, _menuBubbleBlack.default), (0, _defineProperty2.default)(_theme3, _Constant.Themes.GUARANTEED_RATE, _menuBubble.default), (0, _defineProperty2.default)(_theme3, "homepoint", _menuBubbleBlack.default), (0, _defineProperty2.default)(_theme3, _Constant.Themes.SYNERGY_ONE, _menuBubbleBlack.default), (0, _defineProperty2.default)(_theme3, "petersendean", _menuBubble.default), (0, _defineProperty2.default)(_theme3, "caliber", _menuBubble.default), (0, _defineProperty2.default)(_theme3, "pella", _menuBubble.default), _theme3));
var mobileBgColor = (0, _styledTheming.default)('mode', (_theme4 = {}, (0, _defineProperty2.default)(_theme4, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme4, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), (0, _defineProperty2.default)(_theme4, "homepoint", _Constant.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme4, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK), (0, _defineProperty2.default)(_theme4, "caliber", _Constant2.Color.DARK_BLURPLE), (0, _defineProperty2.default)(_theme4, "figure", _Constant2.Color.DARK_BLURPLE), (0, _defineProperty2.default)(_theme4, "petersendean", _Constant2.Color.DARK_BLURPLE), (0, _defineProperty2.default)(_theme4, "pella", _Constant2.Color.DARK_BLURPLE), _theme4));

var HeaderContainer = _styledComponents.default.header(_templateObject(), mobileBgColor, _Constant.Width.MD - 1, _Constant.Width.MD, _Constant2.Color.COTTON_BALL);

var Dropdown = (0, _styledComponents.default)(_Dropdown.Dropdown)(_templateObject2(), _Constant.Width.MD, _Constant.Width.MD - 1); // use of the media query (forced-colors: active) here to support Windows High Contrast mode users, the white menu image was not visible in light themes

var MenuIcon = _styledComponents.default.span(_templateObject3(), _Constant2.Color.BLACK_SOUL, _menuWhite.default, _menu.default, _Constant.Width.MD, MenuBubble);

var MenuDropdownContainer = _styledComponents.default.nav(_templateObject4(), _Constant.Width.MD);

var LogoContainer = _styledComponents.default.div(_templateObject5(), function (_ref) {
  var centerLogoMobile = _ref.centerLogoMobile;
  return centerLogoMobile ? (0, _styledComponents.css)(_templateObject6()) : (0, _styledComponents.css)(_templateObject7());
}, _Constant.Width.MD); // use of the media query (forced-colors: active) here to support Windows High Contrast mode users


var LogoLink = (0, _styledComponents.default)(_Text.AnchorBase)(_templateObject8(), function (_ref2) {
  var $logoWidthMobile = _ref2.$logoWidthMobile;
  return $logoWidthMobile;
}, LogoLight, LogoDark, _Constant.Width.MD, function (_ref3) {
  var $logoWidthTablet = _ref3.$logoWidthTablet;
  return $logoWidthTablet;
}, LogoDark, LogoLight); // VisuallyHidden is used here to assist screen reader users know where the links will take them

var Navbar = function Navbar(_ref4) {
  var menuList = _ref4.menuList,
      centerLogoMobile = _ref4.centerLogoMobile,
      logoWidthMobile = _ref4.logoWidthMobile,
      logoWidthTablet = _ref4.logoWidthTablet,
      url = _ref4.url,
      isRouterLink = _ref4.isRouterLink,
      linkDescription = _ref4.linkDescription;
  return /*#__PURE__*/_react.default.createElement(HeaderContainer, null, /*#__PURE__*/_react.default.createElement(LogoContainer, {
    centerLogoMobile: centerLogoMobile
  }, isRouterLink ? /*#__PURE__*/_react.default.createElement(LogoLink, {
    semanticElement: _reactRouterDom.Link,
    to: url,
    $logoWidthMobile: logoWidthMobile,
    $logoWidthTablet: logoWidthTablet,
    isUnderlined: false
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, linkDescription)) : /*#__PURE__*/_react.default.createElement(LogoLink, {
    href: url,
    $logoWidthMobile: logoWidthMobile,
    $logoWidthTablet: logoWidthTablet,
    isUnderlined: false
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, linkDescription))), /*#__PURE__*/_react.default.createElement(MenuDropdownContainer, null, /*#__PURE__*/_react.default.createElement(Dropdown, {
    id: "dropdown-menu-button",
    toggleButton: /*#__PURE__*/_react.default.createElement(MenuIcon, null, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, "Menu")),
    menuList: menuList,
    menuStyle: {
      right: '0'
    }
  })));
};

Navbar.propTypes = {
  /** A list of components that render when the menu icon is clicked */
  menuList: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  centerLogoMobile: _propTypes.default.bool,
  logoWidthMobile: _propTypes.default.number,
  logoWidthTablet: _propTypes.default.number,
  url: _propTypes.default.string,
  isRouterLink: _propTypes.default.bool,
  linkDescription: _propTypes.default.string
};
Navbar.defaultProps = {
  centerLogoMobile: false,
  logoWidthMobile: 68,
  logoWidthTablet: 96,
  url: '/dashboard',
  isRouterLink: false,
  // this is the description users will hear via screen reader
  linkDescription: 'go to my dashboard'
};
var _default = Navbar;
exports.default = _default;